export { IllustrationMerchantLogoHorizontal } from './illustration-merchant-logo-horizontal';
export { IllustrationMailMotion } from './illustration-mail-motion';
export { IllustrationMerchantCenter } from './illustration-merchant-center';
export { IllustrationLogoG } from './illustration-logo-g';
export { IllustrationCheckmark } from './illustration-checkmark';
export { IllustrationSearch } from './illustration-search';
